@if (itensVistoria.length > 0) {
  <p-accordion [multiple]="true">
    @for (itemVistoria of itensVistoria; track trackPorIndice(ii); let ii = $index) {
      <p-accordion-panel [value]="ii">
        <p-accordion-header>
          <div class="item-cabecalho">
            <p-floatLabel variant="on" class="item-nome-field"
              (mousedown)="$event.stopPropagation()" (click)="$event.stopPropagation()">
              <input pInputText [id]="'itemNomeItem' + ii" class="item-nome-input" [(ngModel)]="itemVistoria.nome" />
              <label [for]="'itemNomeItem' + ii">Item</label>
            </p-floatLabel>
            <span class="estado-bolinha" [ngClass]="'estado-' + (itemVistoria.estadoConservacao ?? 'NAO_INFORMADO')"
              (mousedown)="$event.stopPropagation()"
            (click)="abrirPopoverEstado($event, itemVistoria); $event.stopPropagation()"></span>
            <span class="estado-label">{{ labelEstado(itemVistoria.estadoConservacao) }}</span>
            <button mat-icon-button matTooltip="Remover item" class="btn-remover-item"
              (mousedown)="$event.stopPropagation()" (click)="confirmarRemocao(itemVistoria); $event.stopPropagation()">
              <i class="pi pi-trash"></i>
            </button>
          </div>
        </p-accordion-header>
        <p-accordion-content>
          @for (atributo of itemVistoria.atributos; track atributo; let ai = $index) {
            <div class="linha-atributo">
              @if (!nomeAtributoEditavel(atributo)) {
                <span class="atributo-nome">{{ atributo.nome }}:</span>
              }
              @if (nomeAtributoEditavel(atributo)) {
                <p-floatLabel variant="on" class="atributo-nome">
                  <input pInputText [id]="'atributoNome' + ii + '-' + ai" class="atributo-nome-input" [(ngModel)]="atributo.nome" />
                  <label [for]="'atributoNome' + ii + '-' + ai">Atributo</label>
                </p-floatLabel>
              }
              @if (ehAtributoAvulsoNovo(atributo)) {
                <p-selectButton
                  class="tipo-atributo"
                  [options]="opcoesTipoAtributo"
                  [(ngModel)]="atributo.ehFoto"
                  [allowEmpty]="false"
                  optionLabel="label"
                  optionValue="value">
                </p-selectButton>
              }
              @if (!atributo.ehFoto) {
                <textarea pTextarea rows="1" [id]="'atributoValor' + ii + '-' + ai"
                [(ngModel)]="atributo.valor" class="atributo-valor-input"></textarea>
              }
              @if (atributo.ehFoto) {
                <div class="atributo-foto-grupo">
                  <input #fileInput type="file" accept="image/*" multiple hidden
                    [id]="'atributoFotoInput' + ii + '-' + ai" (change)="onFotosSelecionadas($event, atributo)" />
                  <input #cameraInput type="file" accept="image/*" capture="environment" hidden
                    [id]="'atributoCameraInput' + ii + '-' + ai" (change)="onFotosSelecionadas($event, atributo)" />
                    <!-- No computador o capture é ignorado e "Tirar foto" abriria o mesmo seletor de arquivos:
                      o menu só aparece em tela de toque (SCSS). -->
                    <button mat-stroked-button type="button" class="btn-adicionar-foto-arquivo" (click)="fileInput.click()">
                      <i class="pi pi-plus"></i> Adicionar foto
                    </button>
                    <button mat-stroked-button type="button" class="btn-adicionar-foto-menu" [matMenuTriggerFor]="menuAdicionarFoto">
                      <i class="pi pi-plus"></i> Adicionar foto
                    </button>
                    <mat-menu #menuAdicionarFoto="matMenu">
                      <button mat-menu-item class="opcao-tirar-foto" (click)="tirarFoto(cameraInput)">
                        <i class="pi pi-camera"></i> Tirar foto
                      </button>
                      <button mat-menu-item class="opcao-escolher-galeria" (click)="fileInput.click()">
                        <i class="pi pi-images"></i> Escolher da galeria
                      </button>
                    </mat-menu>
                    <span class="atributo-fotos-count">{{ atributo.fotos.length }} foto{{ atributo.fotos.length === 1 ? '' : 's' }}</span>
                    @if (atributo.fotos.length > 0) {
                      <button mat-icon-button type="button" class="btn-ver-fotos" matTooltip="Ver fotos"
                        (click)="abrirPopoverFotos($event, atributo)">
                        <i class="pi pi-eye"></i>
                      </button>
                    }
                  </div>
                }
                @if (ehAtributoAvulsoNovo(atributo) || editarModelo) {
                  <button mat-icon-button matTooltip="Remover atributo"
                    class="btn-remover-atributo"
                    (click)="confirmarRemocaoAtributo(itemVistoria, atributo)">
                    <i class="pi pi-trash"></i>
                  </button>
                }
              </div>
            }
            @if (itemVistoria.atributos.length === 0) {
              <p class="sem-atributos">Nenhum atributo cadastrado.</p>
            }
            <button mat-stroked-button type="button" class="btn-adicionar-atributo" (click)="adicionarAtributoAvulso(itemVistoria)">
              <i class="pi pi-plus"></i> Adicionar atributo
            </button>
            <hr class="divisor-campos-fixos" />
            <div class="linha-atributo">
              <span class="atributo-nome">Estado:</span>
              <p-selectButton
                [options]="opcoesEstadoConservacao"
                [(ngModel)]="itemVistoria.estadoConservacao"
                optionLabel="label"
                optionValue="value">
              </p-selectButton>
            </div>
            <div class="linha-atributo">
              <span class="atributo-nome">Observação:</span>
              <textarea pTextarea rows="1" [id]="'itemObservacao' + ii"
              [(ngModel)]="itemVistoria.observacao" class="atributo-valor-input"></textarea>
            </div>
          </p-accordion-content>
        </p-accordion-panel>
      }
    </p-accordion>
  }

  <p-popover #popoverFotos appendTo="body">
    @if (atributoPopoverFotos; as atributo) {
      <div class="popover-fotos">
        @for (foto of atributo.fotos; track foto) {
          <div class="foto-miniatura" [class.foto-pendente]="foto.arquivo">
            <img [src]="fotosVistoriaService.miniatura(vistoriaId, foto)" alt="Foto" (click)="ampliarFoto(foto)" />
            @if (foto.arquivo) {
              <span class="foto-nao-salva" matTooltip="Ainda não salva — sobe no próximo Salvar">Não salva</span>
            }
            <button mat-icon-button type="button" class="btn-remover-foto" matTooltip="Remover foto"
              (click)="confirmarRemocaoFoto(atributo, foto)">
              <i class="pi pi-times"></i>
            </button>
          </div>
        }
        @if (atributo.fotos.length === 0) {
          <p class="sem-fotos">Nenhuma foto.</p>
        }
      </div>
    }
  </p-popover>

  @if (fotoAmpliada) {
    <div class="foto-ampliada-fundo" (click)="fecharFotoAmpliada()">
      <img [src]="fotosVistoriaService.fotoCheia(vistoriaId, fotoAmpliada)" alt="Foto ampliada" />
    </div>
  }

  <p-popover #popoverEstado appendTo="body">
    <span>{{ labelEstado(itemPopoverEstado?.estadoConservacao ?? null) }}</span>
  </p-popover>

  @if (itensVistoria.length === 0) {
    <p class="sem-itens">Nenhum item adicionado ainda.</p>
  }

  <div class="adicionar-item">
    @if (itensModelo.length > 0) {
      <app-generic-autocomplete
        class="select-item-modelo"
        [items]="itensDisponiveis"
        displayField="nome"
        label="Selecionar item do modelo"
        inputId="itemModeloSelecionado"
        [ngModel]="null"
        (selectionChange)="adicionarItem($event)">
      </app-generic-autocomplete>
    }
    <button mat-stroked-button type="button" (click)="popoverOutroItem.toggle($event)">
      <i class="pi pi-plus"></i> Adicionar outro item
    </button>
  </div>

  <p-popover #popoverOutroItem appendTo="body">
    <div class="popover-outro-item-content">
      @if (itensForaDoComodo.length > 0) {
        <app-generic-autocomplete
          [items]="itensForaDoComodo"
          displayField="nome"
          label="Buscar item do modelo"
          inputId="itemForaDoComodoSelecionado"
          [ngModel]="null"
          (selectionChange)="adicionarItem($event); popoverOutroItem.hide()">
        </app-generic-autocomplete>
      }

      <button mat-stroked-button type="button" (click)="adicionarItemAvulso(); popoverOutroItem.hide()">
        Criar item sem modelo
      </button>
    </div>
  </p-popover>
